<template>
  <entry-status-component :trayOption=true></entry-status-component>
</template>

<script>
import Vue from 'vue'
import EntryStatusComponent from './components/EntryStatusComponent'

export default {
  name: 'SecurityPoint',
  components: {
    EntryStatusComponent,
  }
}

</script>
